import React from "react"

import "./leftworktext.scss"

/**
 * input with buttons
 * @component
 * @param  {object} props
 * @param  {function} props.handler - function for input
 * @param {function} props.changes - function for button
 * @param  {string} props.value - input value
 * @param  {string} props.name - icon url for button icon
 
 *
 * @example
 * const handler = () => {}
 * const changes = () => {}
 * const value = 'string'
 * const name = 'name'

 *
 * return (
 *  <Input 
 *    handler={handler}
 *    changes={changes}
 *    value={value}
 *    name={name}
 *  />
 * )
 */

const Input = props => {
  const {value = "", name = "", handler = () => {}, changes = () => {}} = props

  return (
    <div className="leftWorkTextInput">
      <button name="minus" className="leftWorkTextInput_btn" onClick={handler}>
        -
      </button>
      <input
        className="leftWorkTextInput_inpt"
        name={name}
        type="text"
        value={value}
        onChange={changes}
      />
      <button name="plus" className="leftWorkTextInput_btn" onClick={handler}>
        +
      </button>
    </div>
  )
}

export default Input
